// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabular-data {
  margin-left: 11%;
  margin-right: 11%;
}
.tabular-data ion-row ion-col {
  padding: 4px 4px;
}
@media screen and (max-width: 479px) {
  .tabular-data ion-row ion-col {
    font-size: 11px;
  }
}
.tabular-data .col-header {
  font-weight: bold;
}

.row {
  white-space: nowrap;
  display: flex;
  justify-content: center;
}

.header-grid {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/limits-history/limits-history.component.scss"],"names":[],"mappings":"AAAA;EAEI,gBAAA;EACA,iBAAA;AAAJ;AAGQ;EACI,gBAAA;AADZ;AAGY;EAHJ;IAIQ,eAAA;EAAd;AACF;AAII;EACI,iBAAA;AAFR;;AAMA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAHJ","sourcesContent":[".tabular-data {\r\n\r\n    margin-left: 11%;\r\n    margin-right: 11%;\r\n\r\n    ion-row {\r\n        ion-col {\r\n            padding: 4px 4px;\r\n\r\n            @media screen and (max-width: 479px) {\r\n                font-size: 11px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .col-header {\r\n        font-weight: bold;\r\n    }\r\n}\r\n\r\n.row {\r\n    white-space: nowrap;\r\n    display: flex;\r\n    justify-content: center\r\n}\r\n\r\n.header-grid {\r\n    width: 100%;\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
